import { Box, Typography } from "@mui/material";
import { boxStyle } from "./styles";

export const H1 = ({ children, label }: { label: string; children?: JSX.Element | null }) => (
  <Box sx={boxStyle}>
    <Typography variant="h1">{label}</Typography>
    <div>{children}</div>
  </Box>
);
